var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper solistic-view-card"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "document-view-body"
  }, [_vm._m(1), _c('div', {
    staticClass: "directory-block"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.data.user_info.first_name) + " " + _vm._s(_vm.data.user_info.last_name))]), _c('h6', [_vm._v(_vm._s(_vm.data.user_info.address1))]), _c('h6', [_vm._v(_vm._s(_vm.data.user_info.city) + ", " + _vm._s(_vm.data.user_info.state) + " " + _vm._s(_vm.data.user_info.zip))])]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("July 29th, 2025")]), _vm._m(2), _vm._m(3), _c('p', [_vm._v(" Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT). ")]), _c('br'), _vm._m(4), _vm.filteredPlanInfo.length ? _c('div', {
    staticClass: "new-rate-details"
  }, [_c('ul', [_c('li', [_vm._v("Plan: "), _c('strong', [_vm._v(_vm._s(_vm.all_plans))])]), _vm.planRate ? _c('li', [_vm._v("Plan Rate: "), _c('strong', [_vm._v("$" + _vm._s(parseFloat(_vm.planRate.new_rate).toFixed(2)))])]) : _vm._e(), _vm.assocFee ? _c('li', [_vm._v("Association Fee: "), _c('strong', [_vm._v("$" + _vm._s(parseFloat(_vm.assocFee.new_rate).toFixed(2)))])]) : _vm._e(), _c('li', [_vm._v("Total: "), _c('strong', [_vm._v("$" + _vm._s(_vm.totalRate.toFixed(2)))])])])]) : _vm._e(), _vm._m(5), _vm._m(6), _c('br'), _c('p', [_c('span', [_vm._v("Broker: "), _c('b', [_vm._v(_vm._s(_vm.data.other_info.agent_name))])]), _c('span', {
    staticStyle: {
      "margin-left": "14%"
    }
  }, [_vm._v("Phone: "), _c('b', [_vm._v(_vm._s(_vm.data.other_info.agent_phone))])])]), _c('br'), _vm._m(7)])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Solistic View Details")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('img', {
    staticClass: "elevate-logo",
    attrs: {
      "src": require("@/assets/images/darknuera.png"),
      "alt": "NuEra Logo"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Dear Valued Member,")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" As of "), _c('strong', [_vm._v("July 1st, 2025")]), _vm._v(", your current Solistic plan will be billed at the updated renewal rate, which was renewed on "), _c('strong', [_vm._v("June 1, 2025")]), _vm._v(". There is nothing you need to do on your end as the renewal is automatic. This is just a formal notification of the rate change. ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Your new rate for your Solistic plan as of July 1st, 2025 will be as follows:")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "osf"
  }, [_c('em', [_vm._v("This new rate will be effective until the next renewal on "), _c('strong', [_vm._v("June 30, 2026.")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "osf"
  }, [_c('em', [_vm._v("If you have any questions, you may contact your representative or broker.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "doc-footer"
  }, [_c('p', [_c('strong', [_vm._v("Sincerely,")])]), _c('p', {
    staticClass: "osf"
  }, [_vm._v("NEB Billing Services")])]);
}]

export { render, staticRenderFns }